import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { AppTitleStrategy } from './title-strategy';
import { auth401Interceptor } from './auth/auth-401.interceptor';
import { sessionIdInterceptor } from './auth/session-id.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // Router uses the TitleStrategy DI token; AppComponent injects the
    // concrete AppTitleStrategy class to call setBadge(). Without an
    // aliased useExisting, Angular creates TWO instances (one per
    // token) — Router updates the panel name on instance A while
    // AppComponent pushes the badge into instance B, so whichever
    // wrote to document.title last wins and the panel name gets
    // clobbered by every badge push. Alias both tokens to the same
    // singleton. Mike 2026-07-14 screenshot ('♪N F2 Admin' with no
    // 'Dashboard' body).
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    { provide: AppTitleStrategy, useExisting: TitleStrategy },
    provideAnimations(),
    // sessionIdInterceptor runs FIRST so the header is on the outbound
    // request; auth401Interceptor runs after and catches errors on the
    // way back up. Order matters only for request-side stamping vs
    // response-side handling — both compose cleanly here.
    provideHttpClient(withInterceptors([sessionIdInterceptor, auth401Interceptor])),
    provideToastr({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      progressBar: true
    }),
  ]
};
